import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

const painPoints = [
  {
    icon: "ri-global-line",
    title: "No website at all",
    desc: "Without an online presence, you&apos;re invisible to customers who search before they buy — and that&apos;s most of them.",
  },
  {
    icon: "ri-search-eye-line",
    title: "Not showing on Google",
    desc: "Your competitors are ranking above you. Potential customers can&apos;t find you even when they&apos;re actively looking for what you offer.",
  },
  {
    icon: "ri-mail-close-line",
    title: "No calls, no enquiries",
    desc: "You have a site but it&apos;s not converting. Visitors land, look around, and leave — without picking up the phone or filling in a form.",
  },
];

export default function ProblemSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="bg-stone-50 section-pad" ref={ref}>
      <div className="container-md">
        <div
          className={`text-center mb-14 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="text-accent text-xs font-semibold uppercase tracking-[0.2em] mb-4 block">
            Sound familiar?
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-zinc-900 leading-tight">
            Struggling to get customers online?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {painPoints.map((point, i) => (
            <div
              key={point.title}
              className={`group border border-zinc-200 rounded-2xl p-8 bg-white hover:border-accent/50 transition-all duration-500 hover:bg-orange-50/30 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-xl mb-5 group-hover:bg-accent/20 transition-colors">
                <i className={`${point.icon} text-2xl text-accent`} />
              </div>
              <h3 className="font-heading text-xl font-semibold text-zinc-900 mb-3">{point.title}</h3>
              <p
                className="text-zinc-500 text-sm leading-relaxed"
                dangerouslySetInnerHTML={{ __html: point.desc }}
              />
            </div>
          ))}
        </div>

        <div
          className={`mt-12 text-center transition-all duration-700 delay-500 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          <p className="text-zinc-500 text-base">
            You&apos;re not alone —{" "}
            <span className="text-zinc-900 font-medium">
              most small business owners face exactly these challenges.
            </span>
            {" "}We fix all three.
          </p>
        </div>
      </div>
    </section>
  );
}
